<template>
  <table class="listado table table-hover">
    <thead class="bg-primary text-white">
      <th-ordenado width="360" titulo="Nombre" campo="nombre" />
      <th-ordenado titulo="Campaña" campo="campaniaId" class="text-center" />
      <th-ordenado titulo="Tipo" campo="tipo" class="text-center" />
      <th title="Comportamientos" class="text-right">Comp.</th>
      <th class="th-acciones">Acciones</th>
    </thead>
    <tbody>
      <tr v-for="modulo in modulos" :key="modulo.id" role="button">
        <td @click="editarModulo(modulo.id)">
          {{ modulo.nombre }}
        </td>
        <td @click="editarModulo(modulo.id)" class="text-center">
          <b-badge v-if="modulo.visibleEnTodasCampanias" variant="success"> Todas </b-badge>
          <span v-else-if="modulo.campanias">
            <b-badge variant="primary" class="mr-2" v-for="(c, idx) in campanias(modulo.campanias)" :key="idx">
              {{ c }}
            </b-badge>
          </span>
          <span v-else>
            <b-badge
              v-b-tooltip.hover.left
              variant="danger"
              title="Este módulo no será visible porque no está presente en ninguna campaña. Desactive el check de personalizar campañas en el módulo o bien elija una o más campañas"
            >
              Ninguna
            </b-badge>
          </span>
        </td>

        <td @click="editarModulo(modulo.id)" class="text-center">
          {{ nombreTipo(modulo.tipo) }}
        </td>

        <td class="text-right" @click="editarModulo(modulo.id)">
          <v-icon
            v-if="modulo.permiteCambioPrecio"
            v-b-tooltip.hover
            name="dollar-sign"
            width="24"
            class="mr-2"
            title="Precio editable"
          />
          <v-icon
            v-if="modulo.permiteCambioHoras"
            v-b-tooltip.hover
            name="clock"
            width="24"
            title="Horas editables"
            class="mr-2"
          />
          <v-icon
            v-if="modulo.cubreCosteDeImplementacion"
            v-b-tooltip.hover
            name="box"
            width="24"
            class="mr-2"
            title="Cubre costes de implantación"
          />
        </td>

        <td nowrap="nowrap" class="td-acciones">
          <b-button-group size="sm">
            <b-button variant="primary" class="actionButton" :to="`/modulos/editar/${modulo.id}`">
              <v-icon variant="primary" name="edit" width="16" />
              <span>Editar</span>
            </b-button>

            <b-button variant="warning" class="actionButton" :to="`/modulos/editarPrecios/${modulo.id}`">
              <v-icon variant="primary" name="dollar-sign" width="16" />
              <span> Precios </span>
            </b-button>

            <b-dropdown size="sm" right text="" variant="dark" class="actionButton">
              <template slot="button-content">
                <v-icon variant="primary" name="menu" width="16" />
              </template>
              <b-dropdown-item size="sm" :to="`/modulos/editarHoras/${modulo.id}`">
                <v-icon variant="primary" name="clock" width="16" />
                <span> Editar Horas</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-button-group>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <sin-registros v-if="!modulos.length" :colspan="5" />
    </tfoot>
  </table>
</template>
<script>
import { nombre as nombreTipo, color as colorTipo } from "@/enums/TipoModulo";

export default {
  props: {
    modulos: Array,
  },
  methods: {
    nombreTipo,
    colorTipo,
    campanias(value) {
      if (value == "") {
        return "-";
      } else {
        return value.toString().split(",");
      }
    },
    editarModulo(moduloId) {
      this.$router.push("/modulos/editar/" + moduloId);
    },
  },
};
</script>

<style>
.listado .badge {
  font-size: 0.9em;
  line-height: 1.1em;
}
</style>
